export default {
  modelName: 'act_cnt_review',
  versionModelName: 'act_version',
  label: '我的覆核法規內容格式作業',
};
